import { Component, OnInit } from '@angular/core';
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment';

@Component({
  selector: 'app-school',
  templateUrl: './school.component.html',
  styleUrls: ['./school.component.css']
})
export class SchoolComponent implements OnInit {


  Submitted: boolean = false;
  SchoolList: any;
  InstitutionType: any;
  Country: any;
  State: any;
  PartnerType: any;
  City: any;
  SelectedFileForUpload: any;
  PartnerList: any;

  constructor(private superadminservice: SuperadminService, private lookupservice: LookupService, 
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SearchModel={
    FromDate:'',
    ToDate:'',
    PartnerID:0,
    CountryID:0,
  }

  ClearSearch(){
    this.SearchModel.FromDate='';
    this.SearchModel.ToDate='';
    this.SearchModel.PartnerID=0;
    this.SearchModel.CountryID=0; 
    this.SchoolList=[];
  }
  GetAllSchool() {
    this.spinnerService.show();
    this.SearchModel.FromDate =this.SearchModel.FromDate!=null && this.SearchModel.FromDate!=''?moment(this.SearchModel.FromDate).format('DD-MMM-YYYY'):'';
    this.SearchModel.ToDate =this.SearchModel.ToDate!=null && this.SearchModel.ToDate!=''?moment(this.SearchModel.ToDate).format('DD-MMM-YYYY'):'';
   
    this.superadminservice.GetAllSchool(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.SchoolList = response.SchoolList;
      this.spinnerService.hide();

    });
  };
  SchoolModel = {
    Address: '',
    DirectorName: '',
    GroupName: '',
    POBox: '',
    Email: '',
    ZipCode: '',
    MobileNo: '',
    Phone: '',
    IsActive: true,
    CountryID: 0,
    CityID: 0,
    StateID: 0,
    SchoolID: 0,
    APPCode: 0,
    JOSAUrl: '',
    LogoPath: '',
    UserID: '',
    Password: '',
    IsAffiliate:false,
    PartnerID:0,
  };

  Clear() {
    this.Submitted = false;
    this.SchoolModel.Address = '';
    this.SchoolModel.GroupName = '';
    this.SchoolModel.POBox = '';
    this.SchoolModel.DirectorName = '';
    this.SchoolModel.Email = '';
    this.SchoolModel.ZipCode = '';
    this.SchoolModel.MobileNo = '';
    this.SchoolModel.Phone = '';
    this.SchoolModel.IsActive = true;
    this.SchoolModel.CountryID = 0;
    this.SchoolModel.StateID = 0;
    this.SchoolModel.CityID = 0;
    this.SchoolModel.SchoolID = 0;
    this.SchoolModel.APPCode = 0;
    this.SchoolModel.JOSAUrl = '';
    this.SchoolModel.LogoPath = '';
    this.SchoolModel.UserID = '';
    this.SchoolModel.Password = '';
    this.SchoolModel.IsAffiliate=false;
    this.SchoolModel.PartnerID=0;

  };


 

  SchoolMarkActive(obj) {
    this.Clear();
    this.SchoolModel.SchoolID = obj.SchoolID;
    this.SchoolModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.superadminservice.SchoolMarkActive(JSON.stringify(this.SchoolModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetAllSchool();
      this.globalHelper.CheckActionStatus(response);

    });
  }

  validationDropDown() {
    return this.SchoolModel.CountryID == 0 || this.SchoolModel.StateID == 0|| this.SchoolModel.CityID == 0;
  }

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };


  SaveSchool(valid) {

    this.Submitted = true;
    if (valid && !this.validationDropDown()) {
      this.spinnerService.show();

      this.superadminservice.SaveSchool(JSON.stringify(this.SchoolModel), (this.SelectedFileForUpload)).subscribe((response: any) => {
        this.GetAllSchool();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response)
      });
    }
  };


  Edit(obj) {
    this.SchoolModel.SchoolID = obj.SchoolID;
    this.SchoolModel.GroupName = obj.GroupName;
    this.SchoolModel.POBox = obj.POBox;
    this.SchoolModel.DirectorName = obj.DirectorName;
    this.SchoolModel.Email = obj.Email;
    this.SchoolModel.ZipCode = obj.ZipCode;
    this.SchoolModel.Phone = obj.Phone;
    this.SchoolModel.MobileNo = obj.MobileNo;
    this.SchoolModel.IsActive = obj.IsActive;
    this.SchoolModel.CountryID = obj.CountryID;
    this.GetState();
    this.SchoolModel.StateID = obj.StateID;
    this.GetCity();
    this.SchoolModel.CityID = obj.CityID;
    this.SchoolModel.ZipCode = obj.ZipCode;
    this.SchoolModel.Address = obj.Address;
    this.SchoolModel.UserID = obj.UserID;
    this.SchoolModel.Password = obj.Password;
    this.SchoolModel.JOSAUrl = obj.JOSAUrl;
    this.SchoolModel.APPCode = obj.APPCode;
    this.SchoolModel.PartnerID = obj.PartnerID;
    this.SchoolModel.IsAffiliate = obj.IsAffiliate;
  };

  ngOnInit() {
    this.GetBindCountry();
    this.GetPartner();
    this.GetAllSchool();


  }


  GetBindCountry() {
    this.lookupservice.GetLookupsList('Country', '').subscribe((data: any) => {
      this.Country = data.LookupItems;
    });
  };


  GetPartner() {
    this.lookupservice.GetLookupsList('Partner', '').subscribe((data: any) => {
      this.PartnerList = data.LookupItems;
    });
  };

  GetState() {
    var Itembo = {
      'ItemId': this.SchoolModel.CountryID
    }
    this.lookupservice.GetLookupsList('State', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.State = data.LookupItems;
    });
  };

  GetPartnerType() {

    this.lookupservice.GetLookupsList('Partner', '').subscribe((data: any) => {
      this.PartnerType = data.LookupItems;
    });
  };

  GetCity() {
    var Itembo = {
      'ItemId': this.SchoolModel.StateID
    }
    this.lookupservice.GetLookupsList('City', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.City = data.LookupItems;
    });
  };

}


